// extracted by mini-css-extract-plugin
module.exports = {"container":"_4bca17e","icon":"_57ef6d8","primaryText":"_fbf9a99","secondaryText":"_004d297"};